// extracted by mini-css-extract-plugin
module.exports = {"markdown":"blog-post-module--markdown--1ovXE","img":"blog-post-module--img--5x0_O","title":"blog-post-module--title--17231"};